module.exports = __webpack_public_path__ + "img/onpremise.94a0f9e2.svg";